import React from 'react';
import ReactDOM from 'react-dom/client';

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
import './scss/custom.scss';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


import HelperEnv from './helpers/HelperEnv';

function loadFile(label, path, type, widType) {

  let scriptEle;
  const url = widType === 'WIDBPF' ? HelperEnv.getWidgetBaseUrl() + path : HelperEnv.getWidgeSFSBaseUrl() + path;
  if (type === 'js') {
    scriptEle = document.createElement("script");
    scriptEle.setAttribute("src", url);
    scriptEle.setAttribute("type", "text/javascript");
    scriptEle.setAttribute("async", true);
  } else if (type === 'css') {
    scriptEle = document.createElement("link");
    scriptEle.setAttribute("href", url);
    scriptEle.setAttribute("rel", "stylesheet");
    scriptEle.setAttribute("async", true);
  }
  if (scriptEle) {
    document.body.appendChild(scriptEle);

    // success event
    scriptEle.addEventListener("load", () => {
      console.log(`${label} File loaded`)
    });
    // error event
    scriptEle.addEventListener("error", (ev) => {
      console.log(`Error on loading ${label} file`, ev);
    });
  }
}

loadFile('Widget 2018 javascript', '/package/index.js', 'js', 'WIDBPF');
loadFile('Widget 2018 css', '/package/main.css', 'css', 'WIDBPF');
loadFile('Widget 2023', '/wid00-sfs-simulation.js', 'js', 'WIDSFS');
const envVariables = HelperEnv.getPathEnvVariables();
let envTitle = ` - ${envVariables.envLabel}`;
if(envVariables.envSuffix){
  envTitle += ` - ${envVariables.envSuffix}`;
}
document.title += envTitle;


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
